import moment from "moment-timezone";
const timezone = 'Asia/Tokyo'

export const toDateTimeString = (dateTimeString: string|undefined) =>
  dateTimeString ? moment(dateTimeString).tz(timezone).format('YYYY/MM/DD HH:mm') : ''
export const toDateTimeISOString = (dateTimeString: string|undefined) =>
  dateTimeString ? moment(dateTimeString).tz(timezone).format('YYYY-MM-DDTHH:mm') : ''
